﻿import { Controller } from "@hotwired/stimulus";

const countdownFrom = 10;

export default class extends Controller {
    static get values() {
        return {
            resendCodeUrl: String
        }
    }

    static get targets() {
        return ["resendCode", "countdown", "successMessage", "failedMessage"];
    }

    connect() {
        if (this.resendCodeTarget.disabled) {
            this.countdown = countdownFrom;
            this.enableResendCodeTargetAfterCountdown();
        }
    }

    enableResendCodeTargetAfterCountdown() {
        const interval = setInterval(
            () => {
                this.countdown--;
                this.countdownTarget.textContent = `(${this.countdown})`;

                if (this.countdown > 0) {
                    return;
                }
    
                this.resendCodeTarget.disabled = false;
                this.countdownTarget.textContent = "";
                clearInterval(interval);
            },
            1000
        );
    }

    async resendCode(e) {
        e.preventDefault();
        e.target.disabled = true;
        this.countdown = countdownFrom;
        this.countdownTarget.textContent = `(${this.countdown})`;
        this.successMessageTarget.classList.add("d-none");
        this.failedMessageTarget.classList.add("d-none");
        const response = await fetch(this.resendCodeUrlValue, { method: "post" });
        const { successfullySentCode } = await response.json();
        this.successMessageTarget.classList.toggle("d-none", !successfullySentCode);
        this.failedMessageTarget.classList.toggle("d-none", successfullySentCode);
        this.enableResendCodeTargetAfterCountdown();
    }
}